import { combineEpics } from 'redux-observable';
import { fetchOrdersEpic } from './fetch-orders.epic';
import { fetchOrderByIdEpic } from './fetch-order-by-id.epic';

export const combinedOrdersEpics = combineEpics(
    fetchOrdersEpic,
    fetchOrderByIdEpic,
);
